import { configureStore } from "@reduxjs/toolkit";
import wizReducer from "./reducers/wizModule";

export const store = configureStore({
  reducer: {
    wiz: wizReducer,
  },
});
